import { Vue } from 'vue-property-decorator'

import MobileDemoCartWidget from '@/components/cart/MobileDemoCartWidget.vue'
import { openModal } from '@/modals/helpers/api'

export function openBundleModal() {
  openModal({
    name: 'mobile-bundle-cart',
    component: MobileDemoCartWidget,
    title: 'Order Summary',
  })
}

export function closeBundleModal() {
  Vue.prototype.$modals.close({ name: 'mobile-bundle-cart' })
}



